import axios from "axios";

import { createStore } from "vuex";
import { router } from '@inertiajs/vue3';

export default createStore({
    state: {
        lastSessionTime: null,
        clearInProccess: false,
        backEndSessionTimeout: 6000,
        sessionStale : false,
    },
    mutations: {
        setLastSessionTime(state, time) {
            state.lastSessionTime = time;
        },
        setStaleSession(state, value) {
            state.sessionStale = value;
        },
        setClearInProccess(state, value) {
            state.clearInProccess = value;
        }
    },
    getters: {
        isSesssionValid : (state) => (currentTime) => {
            if (currentTime < (state.lastSessionTime + state.backEndSessionTimeout)) {
                return true;
            }
            return false;
        }
    },
    actions: {
        async wakeSession() {
            if(this.state.clearInProccess) return;
            this.commit("setClearInProccess", true);
            await axios.get("/session/awake").then((response) => {
                if (response.status == 200) {
                    this.commit("setLastSessionTime", Math.round(+new Date() / 1000));
                    this.commit("setClearInProccess", false);
                }
            }).catch((error) => {
                router.post(route('logout'));
            });
        }
    },
    modules: {

    },
});
